export class InitiationConstants {

  public static readonly CONSULTATION_SUMMARY_HOVER_TEXT: string =
    'Summarize the matters discussed with MARS QRM, including any related guidance or conclusions provided by MARS QRM';
}
